import React, { useState, useContext, useEffect } from 'react'
import Add from '../Icons/Add'
import Decrease from '../Icons/Decrease'
import {
  FoodDetailHeader,
  FoodDetailMiddle,
  FoodDetailBottom
} from './OrderStyle'
import { OrderInfoContext } from '../../contexts/OrderInfo'
import {
  foodDecrease,
  foodIncrease,
  foodTestForMax,
  handleOnShowModel
} from './OrderFunction'
import { OrderDown } from '../Icons/OrderDrawer'
import intl from 'react-intl-universal'
import { OrderMarkContext } from '../../contexts/OrderMark'
import './OrderCss.css'
import request from '../../utils/request'
export default function OrderContentDetails (props) {
  // console.log(props)
  const [flavor, setFlavor] = useState()// 口味
  const [stuff, setStuff] = useState('')// 原料
  const [stuffShow, setStuffShow] = useState('')// 原料
  const [fitPeople, setFitPeople] = useState()// 适合人群
  const [technology, setTechnology] = useState()// 制造工艺
  const [foodName, setfoodName] = useState()// 食物名称
  const [remark, setreMark] = useState()// 备注
  const [unitPrice, setunitPrice] = useState()// 单价
  const OrderInfo = useContext(OrderInfoContext)// 所有食物缓存
  const [itemData, setItemData] = useState()// 食物数据
  const [allergy, setAllergy] = useState()// 饮食禁忌
  const OrderMark = useContext(OrderMarkContext)
  useEffect(() => {
    if (props.itemDataCopy !== null && props.itemDataCopy !== undefined) {
      const tmpData = props.itemDataCopy
      console.log(tmpData)
      if (tmpData.foodID !== undefined && tmpData.foodID !== null) {
        // 128a1b0d6e4b44f198353def49de533e
        request(`/v1/ordering/food/${tmpData.foodID}`, { method: 'GET',
        // request(`/v1/ordering/food/128a1b0d6e4b44f198353def49de533e`, { method: 'GET',
          headers: {
          } })
          .then((res) => {
            if (res.data.allergyList !== null && res.data.allergyList !== undefined) {
              const allergyArr = []
              res.data.allergyList.map((value, index) => {
                allergyArr.push(value.name)
              })
              setAllergy(allergyArr.toString())
            } else {
              setAllergy(undefined)
            }
          })
      }
      // 小锅菜
      if (tmpData.py === undefined) {
        if (tmpData.food !== null && tmpData.food !== undefined) {
          setFlavor(tmpData.food.flavor)
          setStuff(tmpData.food.stuff)
          setStuffShow(tmpData.food.stuff)
          setFitPeople(tmpData.food.fitPeople)
          setTechnology(tmpData.food.technology)
          setfoodName(tmpData.food.foodName)
          setreMark(tmpData.food.remark)
          setunitPrice(tmpData.food.unitPrice)
          setItemData(tmpData)
        }
      } else {
        // 特殊处理（无盐,普食,营养餐)
        setFlavor(tmpData.flavor)
        setStuff(tmpData.stuff)
        setStuffShow(tmpData.stuff)
        setFitPeople(tmpData.fitPeople)
        setTechnology(tmpData.technology)
        setfoodName(tmpData.foodName)
        setreMark(tmpData.remark)
        setunitPrice(tmpData.unitPrice)
        setItemData(tmpData)
      }
    }
  }, [props.itemDataCopy])
  return (
    <div className='h100 bgf'>
      <div
        className='abs zx2 bga flex-center rds20 bgcolor '
        style={{ top: '3%', left: '5%', height: 30, width: 30, backgroundColor: 'rgba(0,0,0,0.4)' }}
        onClick={() => props.setIsShowAdvice(false)}>
        <OrderDown width={18} height={18} />
      </div>
      <div className='h93'>
        <FoodDetailHeader className='h33 ovh zx1 rel lt1'>
          {
            itemData
              ? (itemData.picAddress.indexOf('sodexo') >= 0
                ? <img className='w100 h100' alt={intl.get('No pictures')} src={itemData.picAddress} />
                : <div className='h100 bgf1 vc'>
                  <div className='tc w100 fs40 ga5 lt6'>{intl.get('No pictures')}</div>
                </div>
              )
              : <div className='h100 bgf1 vc'>
                <div className='tc w100 fs40 ga5 lt6'>{intl.get('No pictures')}</div>
              </div>
          }
        </FoodDetailHeader>
        <FoodDetailMiddle className='h25 pl12 pr12 mt-12 bgf lt1' style={{ paddingTop: '6%',height:'30%' }}>
          <div className='h33 rel' style={{ height:'32%',lineHeight:'20px' }}>
            <span className='fs18 g4f ffyy'>{foodName}</span>
          </div>
          <span className='fs11 mb5 rds5 gred bd p1 pl3 pr3  ovs' style={{ display: flavor ? '' : 'none',whiteSpace:'nowrap' }}>{flavor}</span>
          <div className='h30 pt5 g2e'>
            <span className='rds5 bde mr10 pl5 pr5 bged newLine2' style={{ display: stuff ? '' : 'none' }}>
              {stuff && stuff.length > 40 ? (
                <div>{stuff.substr(0, 40)}...
                <span
                  onClick={() => {
                    handleOnShowModel(stuffShow, props.setShowMenuModal, props.setModalInfo, props.setModalTitle, props.setModalOkButton)
                  }} style={{color: '#108ee9'}}>{intl.get('details')}</span></div>) : (<div>{stuff}</div>)}
            </span>
          </div>
          <ul className='flex h36 pb5' style={{ height: '26%' }}>
            <li className='w70 fs21 fw7 priceColor pl5'>&yen;{unitPrice===0?' --':' '+ unitPrice}</li>
            <li className='flex w30 rel h100'>
              {
                foodTestForMax(itemData)
                  ? <div>
                    {<div className='abs fs12 g6 r30 b7'>{intl.get('Sold out')}</div>}
                    <div
                      className={'abs AddPos'}
                      onClick={() => {
                        foodIncrease(itemData, OrderInfo, props.setShowModal, props.setModalInfo, props.chooseDate, OrderMark)
                      }}>
                      <Add height={16} width={16} />
                    </div>
                  </div>
                  : <div>
                    <div
                      className={'abs DecPos' + (itemData ? itemData.selectedQuantity <= 0 ? ' disabled' : '' : '')}
                      onClick={() => {
                        foodDecrease(itemData, OrderInfo)
                      }}>
                      {
                        itemData && itemData.selectedQuantity === 0 ? <Decrease height={16} width={16} /> : <Decrease height={16} width={16} circleBg={'#f31c69'} />
                      }
                    </div>
                    <div className='abs w29px tc NumPos'>{itemData ? itemData.selectedQuantity ? itemData.selectedQuantity : 0 : 0}</div>
                    <div
                      className={'abs AddPos'}
                      onClick={() => {
                        foodIncrease(itemData, OrderInfo, props.setShowModal, props.setModalInfo, props.chooseDate, OrderMark)
                      }}>
                      <Add height={16} width={16} circleBg={'#f31c69'} />
                    </div>
                  </div>
              }
            </li>
          </ul>
        </FoodDetailMiddle>
        <FoodDetailBottom className='h37 pl12 pt15 pr12 g48 ova lt1'>
          <ul className='g48 mt10 lh2-0 fs12'>
            <li>
              <span className='fw5 g131313'>{intl.get('fitPeople')}</span>
              <span className='pl5 ti1'>{fitPeople}</span>
            </li>
            <li>
              <span className='fw5 g131313'>{intl.get('Allergy')}</span>
              <span className='pl5 ti1'>{allergy}</span>
            </li>
            <li>
              <span className='fw5 g131313'>{intl.get('technology')}</span>
              <span className='pl5 ti1'>{technology}</span>
            </li>
            <li>
              <span className='fw5 g131313'>{intl.get('Details of dishes')}</span>
              <span className='pl5 ti1'>{remark}</span>
            </li>
          </ul>
        </FoodDetailBottom>
      </div>
    </div>
  )
}
